import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export type DataSourceType = 'estimates' | 'reported' | 'predictions';

interface DataSourceSelectProps {
  value: DataSourceType;
  onChange: (value: DataSourceType) => void;
  className?: string;
}

const DATA_SOURCE_OPTIONS: { value: DataSourceType; label: string }[] = [
  { value: 'estimates', label: 'Estimate' },
  { value: 'reported', label: 'Reported' },
  { value: 'predictions', label: 'Predicted' },
];

export function DataSourceSelect({
  value,
  onChange,
  className,
}: DataSourceSelectProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder="Select data source" />
      </SelectTrigger>
      <SelectContent>
        {DATA_SOURCE_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
